import Link from "next/link";
import Image from 'next/image'
import React from "react";
import {css} from "@emotion/react";
import {useSelector} from "react-redux";

// components
import {Grid, Typography} from "@material-ui/core";
import CategoryLabel from '~/components/atoms/categoryLabel'
import CatalogCodeLabel from '~/components/atoms/catalogCodeLabel';
// modules
import {convertItemImagePath} from "../../../../stores/tools/commons";
import colorPalette from "../../../../styles/theme/colorPalette";

// resources
import DummyImage from "~/images/common/loader.gif"
import {dataSortCategories, dataSortOrders, itemDataUnit} from '../../../../data/shop/itemSearchOption'
import TempNormal from "../../../../../public/images/common/temperature_normal.svg"
import TempFrozen from "../../../../../public/images/common/temperature_frozen.svg"
import {Skeleton} from "@mui/material";

export const ItemCard = (props) => {
  const { name, code, stock_id, ...data } = props.data
  const placeholder = 'data:image/gif;base64,R0lGODlhGQAZALMAAP///+fn58/Pz7m5uaGhoZ+fn52dnYmJiQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAACH/C05FVFNDQVBFMi4wAwEAAAAh+QQFBwAIACwCAAIAFQAVAAAERRDJSQG9+NrMa6cBtlFGFnpkd0ojUn7r+H7IKs10rn9C7wsZg3CI2xmPg0tBl5QQJstP00mJZqbU6hXzVOq6x2wYAc5EAAAh+QQFBwAIACwCAAIAEgASAAAELxDJSQO9WNrM0eYC9k0AFVZXeZ0apWLs92asNHd4jg18P+jAoJAgRBCHxWNQmYsAACH5BAUHAAgALAIAAgAVAAsAAAQoEMlJBb342sxrpwO2UUEWemR3SiNSfuv4fsgqzXSuf0TvExmAcAiIAAAh+QQFBwAIACwFAAIAEgASAAAELhDJiQa9WNrMa0cEtlECFVKjVF6nRnLtuMLX/N14fgV8H+jAIAIgHBaJQmRQGQEAIfkEBQcACAAsDAACAAsAFQAABCqQoEmrrPhiqung2Ad6GblN4qmup+C+AitXwQlQNXbjOpZPOxolaGMRNxEAIfkEBQcACAAsBQAFABIAEgAABC4QyUkpqbjezDfH3meJZGlyQ6oOZ0sClSDCUjDJGV1TOKXvPB/GFhMRW8dTEhMBACH5BAUHAAgALAIADAAVAAsAAAQnEMgJkL2I6E2w/2AojoE3jFdpCddJYmwrqlcsf3T9uaiNfr4fbBQBACH5BAkHAAgALAIAAgAVABUAAAQzEMlJq7046w227h4GhtZIUuaprlPgvgErz5ZQEaEtDROu6TuK7wIMCokW3i2kZDVXT0sEADs='

  const searchOptionState = useSelector((state) => state.itemSearchOption)

  return(
      <div css={itemBox}>
        {
          data && data.find_labels !== undefined &&
          data.find_labels.filter(label => label === 'NEW').length > 0 &&
          <div css={newTag}>
            NEW
          </div>
        }
        <div css={codeAndTemp}>
          <CatalogCodeLabel quantity={data.quantity_terms} code={code} />
          <div css={tmpIcon}>
            {
              data.shipping_temperature === '冷凍' &&
              <TempFrozen />
              || data.shipping_temperature === '常温' &&
              <TempNormal />
            }
          </div>
        </div>
        <div css={itemInner}>
          {
            // fetchするより先に単位が表示されてしまう為、表示タイミングを合わせている
            // 他にいい方法ないですかね…
            // ちなみに' 'の理由は初期データが空白文字のため(nullだと表示領域が潰れる)
            name !== ' ' &&
            dataSortCategories[searchOptionState.sortCategoryIndex].code !== 'code' &&
            <div>
              <span css={sortCategory}>{ dataSortCategories[searchOptionState.sortCategoryIndex].label }</span>
              <span css={sortValue}>
                  { data[dataSortCategories[searchOptionState.sortCategoryIndex].code] || '-' }
                { itemDataUnit[searchOptionState.sortCategoryIndex].unit }
                </span>
            </div>
          }
          <div css={itemImage}>
            <Link
                href={{
                  pathname: '/items/[catalogCode]',
                  query: {catalogCode: code},
                }}
                prefetch={false}
            >
              <a>
                {/*<div css={{width: '100%', paddingTop: '100%'}}>*/}
                <>
                  {
                    stock_id && stock_id !== '' ?
                        // eslint-disable-next-line @next/next/no-img-element
                        // <img src={ convertItemImagePath(stock_id, 't1') } width={'100%'} css={{marginTop:'-100%'}} alt={name} loading={'lazy'} placeholder={'blur'} blurDataURL={placeholder}/>
                        <Image src={ convertItemImagePath(stock_id, 't1') } width={192} height={192} alt={name} loading={'lazy'} placeholder={'blur'} blurDataURL={placeholder}/>
                        :
                        <Image src={DummyImage} alt={name} width={192} height={192} loading={'lazy'} css={{filter: 'blur(20px)'}}/>
                  }
                </>
              </a>
            </Link>
          </div>
          {
            data.major_category_code && <CategoryLabel categoryCode={data.major_category_code} spMode={true}/>
          }
          <Typography css={itemName}>
            <Link href={{
              pathname: '/items/[catalogCode]',
              query: {catalogCode: code},
            }}
                  prefetch={false}
            >
              <a>
                {
                  name
                }
              </a>
            </Link>
          </Typography>
          <div css={price}>
            {`¥ ${data.discount_price && Number(data.discount_price).toLocaleString() || '-'}`}
          </div>
        </div>
      </div>
  )
}

const itemBox = css`
  padding: 24px 0;
  //box-shadow: 0 0 10px 5px rgb(0 0 0 / 4%);
  box-shadow: 0 0 16px 0px rgb(0 0 0 / 10%);
  border-radius: 16px;
  min-height: 260px;
  height: 100%;
  position: relative;
  overflow: hidden;
`

const itemName = css`
  min-height: 2rem;
  margin: 0 0 16px;
`

const itemImage = css`
  margin-top: 8px;
  min-width: 100px;
  min-height: 100px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  div {
    border-radius: 8px;
  }
  img {
    transition: transform;
    transition-duration: 0.2s;
  }
  &:hover {
    img {
      transform: scale(1.2);
    }
  }
`

const itemInner = css`
  padding: 8px 16px 0;
`

const sortCategory = css`
  color: ${colorPalette.gray};
  font-size: 1.4rem;
  margin-right: 0.5rem;
`

const sortValue = css`
  color: ${colorPalette.primary};
  font-size: 1.8rem;
`

const codeAndTemp = css`
  display: flex;
`

const tmpIcon = css`
  width: 24px;
  height: 24px;
  margin-left: 1rem;
`

const newTag = css`
  background-color: #fefa7b;
  color: ${colorPalette.primary};
  padding: 0 1.4rem;
  font-size: 1.4rem;
  font-weight: 600;
  position: absolute;
  top: 0;
  right: 0;
  border-radius: 0 0 0 16px;
`

const price = css`
  position: absolute;
  bottom: 12px;
  right: 18px;
  text-align: right;
  font-size: 1.6rem;
`
